import { ControlledDateTimeInput } from 'modules/shared/components';

/**
 * InlineApproveSection
 *
 * Inline approval UI for scheduling the next interview.
 * Renders a date-time input bound to a single react-hook-form field
 * and exposes confirm / cancel actions.
 *
 * This component must be rendered within a react-hook-form FormProvider.
 *
 * Props:
 * @param {string} name - Form field name for the scheduled datetime.
 * @param {string} [label='Schedule next interview'] - Input label.
 * @param {Function} [onCancel] - Invoked when the cancel action is triggered.
 * @param {Function} onConfirm - Invoked when the confirm action is triggered.
 * @param {boolean} [disabled=false] - Disables input and actions when true.
 *
 * Notes:
 * - The field value represents a full datetime.
 * - `id` is derived from `name` for label association.
 */
export default function InlineApproveSection(props) {
  const {
    name,
    label = 'Schedule next interview',
    onCancel = () => {},
    onConfirm = () => {},
    disabled,
  } = props;

  return (
    <div className='column'>
      <ControlledDateTimeInput
        id={name}
        name={name}
        label={label}
        orientation='row'
        disabled={disabled}
        rules={{ required: 'Interview date & time is required' }}
        disablePast
        sx={{ '& > div': { justifyItems: 'flex-end' } }}
      />
      <div className='row gap-3 self-end'>
        <button type='button' className='btn text-btn underline' onClick={onCancel}>
          Cancel
        </button>

        <button
          type='button'
          className='btn cta-outlined-btn'
          onClick={onConfirm}
          disabled={disabled}
        >
          Save
        </button>
      </div>
    </div>
  );
}
